export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') !== -1) {
    return true
  }
  return true
}

export function isQYWeixin() {
  // if (process.env.NODE_ENV === 'development') {
  //   return true
  // }
  var ua = navigator.userAgent.toLowerCase()
  if ((ua.indexOf('micromessenger') !== -1 && ua.indexOf('wxwork') !== -1)) {
    return true
  }
  return false
}

export function isIOS() {
  var u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export function isAndroid() {
  var u = navigator.userAgent.toLowerCase()
  return u.indexOf('android') > -1 || u.indexOf('adr') > -1
}

export function isWindows() {
  var agent = navigator.userAgent.toLowerCase()
  return agent.indexOf('windows') !== -1
}
